import { sections } from '../../constants'

const supportedSections = [
  sections.header,
  sections.hero,
  sections.body,
  sections.col1,
  sections.col2,
  sections.footer
]

export default supportedSections
